<div class="modal-backdrop" *ngIf="isVisible"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': isVisible ? 'block' : 'none'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Workflow Note</h5>
        <button type="button" class="close" aria-label="Close" (click)="onClose()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="successMessage" class="alert alert-success text-center" role="alert">
          {{ successMessage }}
        </div>
        <table class="table table-sm table-bordered  table-hover mb-3">
          <tbody>
            <tr>
              <td class="font-weight-bold">Workflow Title:</td>
              <td>{{ workflowTitle }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">Entity Name:</td>
              <td>{{ entityName }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">Date Created:</td>
              <td>{{ createdAT | date:'dd-MM-yyyy' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="form-group">
          <label for="note">Note:</label>
          <textarea class="form-control" id="note" rows="5" [(ngModel)]="noteContent" placeholder="Add Workflow Actions Note... "></textarea>
        </div>
      </div>
      <div class="modal-footer d-flex ">
        <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
        <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
      </div>
    </div>
  </div>
</div>